import { useMemo } from 'react';
import type { RangeSpanT } from '../../../../../../../common/types/types';
import { getIsAnnotationSequenceValid } from '../../utils';
import { MAX_TRACKING_FRAMES, SEQUENCE_VALIDATION_ERRORS } from '../constants';
type Range = {
  start: number;
  end: number;
};
type UseSequenceValidationProps = {
  newRange: Range;
  maxFrames: number;
  isTrackingMode?: boolean;
};
export const useSequenceValidation = ({
  newRange,
  maxFrames,
  isTrackingMode = false
}: UseSequenceValidationProps) => {
  const isSequenceValid = useMemo(() => {
    const newAnnotationSequence = new Map<string, RangeSpanT>();
    newAnnotationSequence.set('new', {
      start: newRange.start,
      end: newRange.end
    });
    return getIsAnnotationSequenceValid(newAnnotationSequence, maxFrames);
  }, [newRange, maxFrames]);
  const isTrackingValid = useMemo(() => {
    if (!isTrackingMode) return true;
    const frameCount = newRange.end - newRange.start + 1;
    return frameCount <= MAX_TRACKING_FRAMES;
  }, [newRange, isTrackingMode]);
  const validationError = useMemo(() => {
    if (!isSequenceValid) {
      return SEQUENCE_VALIDATION_ERRORS.SEQUENCE_VALIDATION_ERROR;
    }
    if (isTrackingMode && !isTrackingValid) {
      return SEQUENCE_VALIDATION_ERRORS.TRACKING_VALIDATION_ERROR;
    }
    return null;
  }, [isSequenceValid, isTrackingValid, isTrackingMode]);
  return {
    isSequenceValid,
    isTrackingValid,
    validationError
  };
};